import React from 'react';

import { LeafPortal, PortalNode } from 'helpers/PortalNodeManager';

import css from 'styles/components/productdetail/productGallery/addToCollection.scss';

interface AddToCollectionProps {
  collectionNode: PortalNode;
}

/**
 * Add to collection heart <3
 * Current limitation of this component is that it can only appear once on a page
 *  it gets confused with which parent to attach to
 * @returns {FunctionComponent}
 */
const AddToCollection = ({ collectionNode }: AddToCollectionProps) => (
  <div className={css.addToCollection}>
    <LeafPortal node={collectionNode} />
  </div>
);

export default AddToCollection;
